<template>
   <div v-if="preloader">
    <template>
      <bubble-loader/>
    </template>
  </div>

  <div v-else>
    <v-card
      height="64px"
      width="100%"
      class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
      style="
        position: fixed;
        z-index: 200;
        top: 0;
        width: 98%;
        padding-top: 16px;
      "
    >
      <v-card-title class="pl-0 ml-0">
        <p
          class="breadcrumb-text-unselected underline-on-hover cursor"
          @click="$router.push('/users')"
        >
          Users
        </p>
        <v-icon
          class="breadcrumb-arrow-unselected"
          style="margin-top: 6px !important"
          >mdi-chevron-right</v-icon
        >
        <p class="breadcrumb-text" style="margin-top: 2px">Candidate History</p>
        <v-icon class="breadcrumb-arrow" style="margin-top: 5px !important"
          >mdi-chevron-down</v-icon
        >
      </v-card-title>
    <UserNavMenu/>
    </v-card>
    <div class="repCard text-capitalize">
      <p class="text-h6 family-graphik-medium">Candidate History</p>
      <v-expansion-panels v-model="screenPanel" multiple class="mt-4">
        <v-expansion-panel v-for="(campaign, index) in userHistory" :key="index">
    
          <v-expansion-panel-header>
            <v-row>
  <v-col cols="5">
    <p class="text-subtitle-2 family-graphik-medium">{{ campaign.campaignName }}</p>
  </v-col>

  <v-col cols="7">
    <div class="d-flex align-center justify-end mr-4">
      <v-row class="align-center">
        <!-- Candidate Status -->
        <v-col cols="7" class="pa-0">
          <p class="text-caption">
            Candidate Current Status -
            <v-chip
              class="text-capitalize ml-2"
              :class="getChipColor(campaign.attempts[campaign.attempts.length - 1].latestStatus)"
            >
              {{ campaign.attempts[campaign.attempts.length - 1].latestStatus | interviewStatusMapping  }}
            </v-chip>
          </p>
        </v-col>

        <!-- Rounds Attempted -->
        <v-col cols="5" class="pa-2">
          <p class="text-caption mt-2 ml-6">
            Rounds Attempted -
            <span class="ml-2">
              {{
                userHistory[index].attempts[userHistory[index].attempts.length - 1].evaluations.length
              }}
            </span>
          </p>
        </v-col>
      </v-row>
    </div>
  </v-col>
</v-row>
        </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div class="d-flex flex-column mt-5" v-for="(attempt, attemptIndex) in campaign.attempts " :class="attemptIndex < campaign.attempts.length -1 ? 'bottom-divider':''">
              <div class="d-flex justify-space-between">
                <p class="text-subtitle-2 family-graphik-medium">{{ ordinalMap[attemptIndex+1] }} Attempt</p> <v-chip :class="getChipColor(attempt.latestStatus)">{{ attempt.latestStatus | interviewStatusMapping }}</v-chip>
              </div>
              <div class="my-3">
                <v-row>
                  <v-col>
                    <div class="d-flex flex-column text-caption">
                      <v-row>
                        <v-col cols="4" class="pa-1 pl-3">Candidate Name </v-col>
                        <v-col cols="6" class="pa-1"> <span class="mr-3">-</span> {{ attempt.candidateName | capitalizeFirst }}</v-col>
                      </v-row>
          
                      <v-row>
                        <v-col cols="4"  class="pa-1 pl-3">Preferred Location </v-col>
                        <v-col cols="6"  class="pa-1"> <span class="mr-3">-</span> {{ attempt.prefferedLocation }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="4" class="pa-1 pl-3">Rounds Attempted </v-col>
                        <v-col cols="6" class="pa-1"> <span class="mr-3">-</span> {{campaign.attempts[index].evaluations.length}}</v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="d-flex flex-column text-caption">
                      <v-row>
                        <v-col cols="4" class="pa-1 pl-3">Email Id</v-col>
                        <v-col cols="6" class="pa-1">
                          <span class="text-lowercase"> <span class="mr-3">-</span>{{ attempt.emailId }}</span>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="4" class="pa-1 pl-3">Preferred Job Role</v-col>
                        <v-col cols="6" class="pa-1"> <span class="mr-3 text-capitalize">-</span> {{ attempt.prefferedJobRole }}</v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="4" class="pa-1 pl-3">Campaign Start Date</v-col>
                        <v-col cols="6" class="pa-1"> <span class="mr-3">-</span>{{ formatDate(campaign.campaignStartDate) }}</v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="d-flex flex-column text-caption">
                      <v-row>
                      <v-col cols="4" class="pa-1 pl-3">Phone No</v-col>
                      <v-col cols="6" class="pa-1"><span class="mr-3">-</span> {{ attempt.phoneNo }}</v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="4" class="pa-1 pl-3">Preferred Subject</v-col>
                      <v-col cols="6" class="pa-1"> <span class="mr-3">-</span>{{ attempt?.prefferedSubject.join() }}</v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="4" class="pa-1 pl-3">Campaign End Date</v-col>
                      <v-col cols="6" class="pa-1"><span class="mr-3">-</span> {{formatDate(campaign.campaignEndDate) }}</v-col>
                    </v-row>

                    </div>
                  </v-col>
                </v-row>
              </div>
              <stage-item class="mb-2" :stage="attempt.testHistory" />
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </div>
</template>
<script>
import BubbleLoader from "@/components/BubbleLoader.vue";
import UserNavMenu from "@/components/UserNavMenu.vue";
import StageItem from "./StageItem.vue";
import UsersController from "@/controllers/UsersController";
import { cloneDeep } from "lodash";
export default {
    name: 'UserProfileHistory',
    components: {
        BubbleLoader,
        UserNavMenu,
        StageItem
    },
    async mounted(){
      let {userId,campaignId} = this.$route.query
      this.preloader = true
      await this.getUserHistory(userId,campaignId);
      this.createNestedattempts(this.userHistory);
      this.preloader = false
    },
    data(){
      return {
        preloader: false,
        userHistory: [],
        screenPanel: 0,
        ordinalMap: {
                    1: 'First',
                    2: 'Second',
                    3: 'Third',
                    4: 'Fourth',
                    5: 'Fifth',
                    6: 'Sixth',
                    7: 'Seventh',
                    8: 'Eighth',
                    9: 'Ninth',
                    10: 'Tenth',
                    11: 'Eleventh',
                    12: 'Twelfth',
                    13: 'Thirteenth',
                    14: 'Fourteenth',
                    15: 'Fifteenth',
                    16: 'Sixteenth',
                    17: 'Seventeenth',
                    18: 'Eighteenth',
                    19: 'Nineteenth',
                    20: 'Twentieth',
                    21: 'Twenty First',
                    22: 'Twenty Second',
                    23: 'Twenty Third',
                    24: 'Twenty Fourth',
                    25: 'Twenty Fifth',
                    26: 'Twenty Sixth',
                    27: 'Twenty Seventh',
                    28: 'Twenty Eighth',
                    29: 'Twenty Ninth',
                    30: 'Thirtieth'
                  },
        finalStatusMap:new Map([
          [["closed"], ['closed-txt', 'closed-bg']],
          [["not recommended", "below standard", "rejected", "screening failed", "mains failed", "reject", "rejected"], ['rejected-txt', 'rejected-bg']],
          [["on hold", "moderately recommended", "ONHOLD"], ['hold-txt', 'hold-bg']],
          [["highly recommended", "strongly recommended", "recommended", "mains passed", "screening passed", "interveiw scheduled", "send_to_hiring_manager","accept", "accepted"], ['recommend-bg', 'recommended-txt']]
        ])
      }
    },
    filters: {
       interviewStatusMapping: function(status) {
          switch (status) {
            case 'ACCEPT':
              return 'Accepted';
            case 'REJECT':
              return   'Rejected';
            case 'ONHOLD':
              return  'On Hold';
            case 'INTERVIEW_COMPLETED':
              return 'Interview Completed';
            case 'SEND_TO_HIRING_MANAGER':
              return 'Sent to Hiring Manager';
            case 'NOTIFY_HR':
              return 'Notified HR';
            case 'ROUND_ACCEPTED':
              return 'Round Accepted';
            default:
              return status;
          }
       },
    },
    methods:{
      formatDate(date) {
        const d = new Date(date);
        if (!date || isNaN(d.getTime())) {
          return 'NA';
        }
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        return `${day}/${month}/${year}`;
    },
     async getUserHistory(userId,campaignId){
        if(userId){
              const response = await UsersController.getUserHistory(userId,campaignId)
              if(response.flag){
              this.userHistory = response.data
          }
        }
      },
      getChipColor(rec) {
      for (let [keys, value] of this.finalStatusMap.entries()) {
        if (keys.includes(rec.toLowerCase())) {
          return value;
        }
      }
      return ['default-bg', 'default-txt'];
    },
    createNestedattempts(data){
       data.forEach((item, ) =>{
        if(item.attempts.length > 0  ){
          item.attempts.forEach((attempt, index)=>{
            if(attempt?.evaluations.length > 0){
              attempt['testHistory'] = this.createChild(cloneDeep(attempt.evaluations), {})
            }
          })
        }
      })
    },
    createChild(data, res = {}) {
    res = data[0]
      if(data.length > 0){
          res['child'] = this.createChild(data.slice(1, data.length), res)
      }

      return res    
    }
    }

}
</script>
<style>

.v-application .family-graphik-medium {
  font-family: "GraphikMedium", sans-serif !important;
}
.repCard {
    margin: 80px 12px 0 32px;
}
.v-application .v-expansion-panel-header--active{
  border-bottom: 1px solid #E0E0E0 !important;
}
.bottom-divider {
  border-bottom: 1px solid #E0E0E0;
}
.recommend-txt{
    color:#4D695B !important;
    text-align: left !important;
}
.hold-txt{
    color:#B7842C !important;
    text-align: left !important;
}
.hold-bg{
    background-color: rgba(233, 182, 94, 0.24) !important;
}
.recommend-bg{
    background-color: rgba(95, 159, 104, 0.24)  !important;
}
.closed-bg{
  background: #F9DBED !important;
}
.closed-txt{
  color: #E30C78 !important;
}
.rejected-bg {
    background-color: #F9DBE1 !important;
}
.hold-txt {
    color: #FB7500 !important;
}
.recommended-txt {
    color: #007C2A !important;
}
.rejected-txt {
    color: #D40028 !important;
}
.default-txt{
 color: #3F41D1 !important;
}
.default-bg{
  background-color: #CFD5F1 !important;
}
</style>